<template>
  <v-menu bottom left offset-y :close-on-content-click="false">
    <v-btn
      slot="activator"
      flat
      small
      class="grey lighten-3"
      :style="{ 'text-transform': 'none', margin: '6px 4px' }"
    >
      {{ lang.share }}
    </v-btn>
    <v-card class="pa-2">
      <vc-share-icons
        :twitter-text="twitterText"
        :twitter-hash-tags="twitterHashTags"
        :line-text="lineText"
        :src-url="srcUrl"
        :lang="lang"
        :show-japanese-web-site="showJapaneseWebSite"
      ></vc-share-icons>
    </v-card>
  </v-menu>
</template>

<script>
export default {
  name: "vc-share-button",
  props: {
    twitterText: {
      type: String,
      default: ""
    },
    twitterHashTags: {
      type: String,
      default: ""
    },
    lineText: {
      type: String,
      default: ""
    },
    srcUrl: {
      type: String,
      default: ""
    },
    lang: {
      type: Object,
      default: () => {
        return {};
      }
    },
    showJapaneseWebSite: {
      type: Boolean,
      default: true
    }
  }
};
</script>
